import { Fragment } from "react";
import { Select, Form, Input, Tag, Table, message, Tooltip, Popconfirm, Button, Space } from "antd";
import styles from "../management.module.scss";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import { ColumnsType } from "antd/es/table";
import { useDeviceGroup, useUpdateGroup, useDeleteGroup } from "../queries";

const { Option } = Select;

interface nodeList {
  id: string;
  name: string;
  name_or_id: string;
}

interface groupRecordProps {
  gid: string;
  node_list: nodeList[];
  node_list_name_id?: nodeList[];
  name?: string;
}

interface editGroupProps {
  record: any;
  setCurrentPage: any;
  setEditingKey: any;
  editingKey: any;
  EditGroupform: any;
  GroupModalvisible: boolean;
  devicesNodeInf: any;
}

const EditGroup = ({
  record,
  setCurrentPage,
  setEditingKey,
  editingKey,
  EditGroupform,
  GroupModalvisible,
  devicesNodeInf,
}: editGroupProps) => {
  const { t } = useTranslation();
  const { data: deviceGroups, isFetching: deviceGroupsFetching } = useDeviceGroup(record?.cid, GroupModalvisible);
  const { mutateAsync: updateGroupMutation } = useUpdateGroup();
  const { mutateAsync: deleteGroupMutation } = useDeleteGroup();

  const UpdateGrouponFinish = (values: any) => {
    updateGroupMutation({ values, cid: record.cid })
      .then(() => {
        message.success(t("ISMS.Success"));
        setCurrentPage("2");
        setEditingKey("");
      })
      .catch(() => {
        message.error(t("ISMS.Fail"));
      });
  };

  const deleteGroup = (grouprecord: any) => {
    deleteGroupMutation({ name: grouprecord.name, cid: record.cid })
      .then(() => {
        message.success(t("ISMS.Success"));
      })
      .catch(() => {
        message.error(t("ISMS.Fail"));
      });
  };

  const edit = (index: any) => {
    setEditingKey(index);
  };

  const cancel = () => {
    setEditingKey("");
  };

  const columns: ColumnsType<groupRecordProps> = [
    {
      title: t("ISMS.Group"),
      dataIndex: "name",
      render: (text, record, index) => {
        return (
          <Fragment>
            {text}
            <Form.Item
              style={{ display: "none" }}
              className={styles.formitem}
              name={["Group", index, "name"]}
              initialValue={record.name}
            >
              <Input disabled={true} maxLength={30} />
            </Form.Item>
          </Fragment>
        );
      },
    },
    {
      title: t("ISMS.Device"),
      dataIndex: "node_list_name_id",
      render: (_, record, index) => {
        return (
          <Fragment>
            {index !== editingKey &&
              record?.node_list_name_id?.map((item, index) => (
                <Tag key={index}>{item.name !== "" ? item.name : item.id}</Tag>
              ))}
            <Form.Item
              className={styles.formitem}
              style={index !== editingKey ? { display: "none" } : { marginBottom: 0 }}
              name={["Group", index, "node_list"]}
              initialValue={record.node_list}
            >
              <Select
                mode="multiple"
                placeholder={t("ISMS.Select")}
                style={{ width: "100%" }}
                className={styles.deviceinput}
                // allowClear
                autoClearSearchValue={false}
                optionFilterProp="label"
              >
                {devicesNodeInf?.NodeList?.map((item: nodeList, index: number) => {
                  return (
                    <Option key={index} value={item.id} label={item.name_or_id}>
                      {item.name_or_id}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Fragment>
        );
      },
    },
    {
      title: t("ISMS.Operation"),
      dataIndex: "Operation",
      render: (_, record, index) => {
        return index === editingKey ? (
          <Button
            onClick={() => {
              EditGroupform.setFieldsValue({
                Group: deviceGroups?.tableData || [],
              });
              cancel();
            }}
          >
            Cancel
          </Button>
        ) : (
          <Space size={1}>
            <Tooltip title={t("ISMS.Edit")}>
              <Button
                type="text"
                icon={<EditOutlined />}
                onClick={() => {
                  edit(index);
                }}
              ></Button>
            </Tooltip>

            <Tooltip title={t("ISMS.DeleteGroup")}>
              <Popconfirm
                title={t("ISMS.Sure to delete?")}
                okText={t("ISMS.OK")}
                cancelText={t("ISMS.Cancel")}
                onConfirm={() => {
                  deleteGroup(record);
                }}
              >
                <Button type="text" icon={<DeleteOutlined />}></Button>
              </Popconfirm>
            </Tooltip>
          </Space>
        );
      },
    },
  ];

  return (
    <Form
      //@ts-ignore
      name={["Group"]}
      onFinish={UpdateGrouponFinish}
      autoComplete="off"
      form={EditGroupform}
      className={styles.Form}
      layout="vertical"
    >
      <Table
        columns={columns}
        dataSource={deviceGroups?.tableData || []}
        pagination={false}
        loading={deviceGroupsFetching}
        className={styles.table}
        rowKey={(record: any) => record.name}
        rowClassName="editable-row"
      />
    </Form>
  );
};

export default EditGroup;
